var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckboxChecked(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 24,
    viewBox: "0 0 30 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 23,
    height: 23,
    rx: 4.5,
    stroke: "#1D1817"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5707 18.875H12.4334C11.4281 18.8306 10.484 18.404 9.81407 17.6909L4.26352 12.0072H4.26311C3.73445 11.298 3.60533 10.3877 3.91757 9.57095C4.22982 8.75384 4.94364 8.1341 5.82884 7.9117C6.71361 7.68892 7.65727 7.89204 8.35486 8.45516L12.658 12.8599L25.0444 1.8364C25.5726 1.30257 26.31 1 27.0815 1C27.853 1.00039 28.59 1.30333 29.1182 1.83716C29.6461 2.37099 29.9181 3.08871 29.8694 3.81947C29.8207 4.55023 29.4561 5.22978 28.8612 5.69649L15.1402 17.9041C14.4459 18.5273 13.5267 18.8746 12.5708 18.875L12.5707 18.875Z",
    fill: "#1D1817"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckboxChecked);
export default __webpack_public_path__ + "static/media/checkbox-checked.fca5353392b2b877212b81add23503ed.svg";
export { ForwardRef as ReactComponent };